import { render } from "./App.vue?vue&type=template&id=38273128"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./App.vue?vue&type=style&index=0&id=38273128&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__